import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;

  .updates-list {
    min-width: 0;
  }

  .update-chip {
    white-space: nowrap;
  }

  .update-card {
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.$gray300};
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .update-card-active {
    border-color: ${(props) => props.theme.$success};
  }

  .update-icon {
    width: 32px;
    height: 32px;
    background: ${(props) => props.theme.$gray200};
  }

  .update-icon .material-icons {
    font-size: 18px;
  }

  .update-title {
    color: ${(props) => props.theme.$dark};
  }

  .update-author,
  .update-date {
    font-size: 13px;
  }

  .update-body {
    font-size: 14px;
    color: ${(props) => props.theme.$gray700};
  }

  .update-message + .update-message {
    padding-top: 8px;
    border-top: 1px solid ${(props) => props.theme.$gray200};
  }

  .update-message-head {
    font-size: 12px;
    font-weight: 600;
  }

  .update-pane {
    flex: 0 0 46%;
    min-width: 480px;
    min-height: 0;
  }

  .update-pane-title {
    font-weight: 600;
  }

  .update-pane-body {
    overflow-y: auto;
  }

  .update-pane h4,
  .update-section-title {
    color: ${(props) => props.theme.$dark};
  }

  .update-section-title {
    font-weight: 600;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .update-field-label {
    color: ${(props) => props.theme.$gray600};
    font-size: 14px;
    margin-bottom: 0.25rem;
  }

  .update-field-value {
    color: ${(props) => props.theme.$dark};
  }

  .files-box {
    overflow: hidden;
  }

  .files-table {
    table-layout: fixed;
  }

  .files-table th {
    font-weight: 600;
    color: ${(props) => props.theme.$dark};
    background: ${(props) => props.theme.$gray200};
    border-top: 0;
    border-bottom: 0;
    white-space: nowrap;
  }

  .files-table th,
  .files-table td {
    padding: 1rem 1.5rem;
  }

  .files-table td {
    vertical-align: middle;
    color: ${(props) => props.theme.$dark};
  }

  .files-table .file-date-col {
    width: 32%;
  }

  .files-table .file-actions-col {
    width: 160px;
  }

  .file-actions .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .file-actions .material-icons {
    font-size: 16px;
    line-height: 1;
  }

  .file-preview-row td {
    border-top: 0;
  }

  .file-preview-box {
    height: 50vh;
    min-height: 320px;
  }

  .min-width-0 {
    min-width: 0;
  }

  .material-icons {
    font-size: 16px;
  }

  .notes-input-group .material-icons {
    font-size: 24px;
  }
`;
